/* Rideline feature layer — loads after theme.js */
(function () {
  'use strict';

  var S = window.themeSettings || {};
  var V = window.ridelineSettings || {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function money(cents) {
    var format = S.moneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*amount[^}]*\}\}/, amount).replace(/<[^>]+>/g, '');
  }

  /* ---------- Page transition ---------- */
  if (V.pageTransition) document.body.classList.add('page-fade');

  /* ---------- Back to top ---------- */
  function initBackTop() {
    var btn = $('.back-top-btn');
    if (!btn) return;
    window.addEventListener('scroll', function () {
      btn.classList.toggle('is-visible', window.scrollY > 600);
    }, { passive: true });
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ---------- Inactive tab message ---------- */
  function initTabMessage() {
    if (!V.tabMessage) return;
    var original = document.title;
    document.addEventListener('visibilitychange', function () {
      document.title = document.hidden ? V.tabMessage : original;
    });
  }

  /* ---------- Cookie box ---------- */
  function initCookie() {
    var box = $('.cookie-box');
    if (!box || localStorage.getItem('vh_cookie_ok')) return;
    setTimeout(function () { box.classList.add('is-visible'); }, 1500);
    $('[data-cookie-accept]', box).addEventListener('click', function () {
      localStorage.setItem('vh_cookie_ok', '1');
      box.classList.remove('is-visible');
    });
  }

  /* ---------- Newsletter popup ---------- */
  function initPopup() {
    var pop = $('.nl-popup');
    if (!pop || localStorage.getItem('vh_popup_seen')) return;
    setTimeout(function () {
      pop.classList.add('is-open');
      localStorage.setItem('vh_popup_seen', '1');
    }, (V.popupDelay || 8) * 1000);
    $$('[data-popup-close]', pop).forEach(function (el) {
      el.addEventListener('click', function () { pop.classList.remove('is-open'); });
    });
  }

  /* ---------- Sales popup ---------- */
  function initSalesPop() {
    var el = $('.sales-pop');
    if (!el || !V.salesEntries || !V.salesEntries.length) return;
    var i = 0;
    function show() {
      var e = V.salesEntries[i % V.salesEntries.length];
      i++;
      $('[data-sp-name]', el).textContent = e.name + ' from ' + e.city;
      $('[data-sp-product]', el).textContent = e.product;
      el.classList.add('is-visible');
      setTimeout(function () { el.classList.remove('is-visible'); }, 5000);
    }
    setTimeout(show, 6000);
    setInterval(show, (V.salesInterval || 30) * 1000);
  }

  /* ---------- Fly to cart ---------- */
  function flyToCart(sourceImg) {
    if (!V.flyToCart || !sourceImg) return;
    var cartIcon = $('.site-header [data-cart-open]') || $('.mobile-bar [data-cart-open]');
    if (!cartIcon) return;
    var from = sourceImg.getBoundingClientRect();
    var to = cartIcon.getBoundingClientRect();
    var img = document.createElement('img');
    img.src = sourceImg.currentSrc || sourceImg.src;
    img.className = 'fly-img';
    img.style.left = from.left + from.width / 2 - 32 + 'px';
    img.style.top = from.top + from.height / 2 - 32 + 'px';
    document.body.appendChild(img);
    requestAnimationFrame(function () {
      img.style.left = to.left + to.width / 2 - 12 + 'px';
      img.style.top = to.top + to.height / 2 - 12 + 'px';
      img.style.width = '24px';
      img.style.height = '24px';
      img.style.opacity = '0.4';
    });
    setTimeout(function () { img.remove(); }, 750);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add], [data-atc]');
    if (!btn) return;
    var card = btn.closest('.product-card, .upsell-card, .product-layout, .qv-modal__panel');
    var img = card ? card.querySelector('img') : null;
    flyToCart(img);
  });

  /* ---------- Wishlist (localStorage) ---------- */
  var WISH_KEY = 'vh_wishlist';
  function getWishlist() { try { return JSON.parse(localStorage.getItem(WISH_KEY)) || []; } catch (e) { return []; } }
  function setWishlist(list) {
    localStorage.setItem(WISH_KEY, JSON.stringify(list));
    updateWishCounts();
  }
  function updateWishCounts() {
    var n = getWishlist().length;
    $$('[data-wish-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('has-items', n > 0);
    });
  }
  function initWishlist() {
    updateWishCounts();
    $$('.wish-btn[data-handle]').forEach(function (btn) {
      var wished = getWishlist().some(function (w) { return w.handle === btn.dataset.handle; });
      btn.classList.toggle('is-wished', wished);
    });
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.wish-btn[data-handle]');
      if (!btn) return;
      e.preventDefault();
      var list = getWishlist();
      var idx = list.findIndex(function (w) { return w.handle === btn.dataset.handle; });
      if (idx > -1) {
        list.splice(idx, 1);
        btn.classList.remove('is-wished');
      } else {
        list.unshift({ handle: btn.dataset.handle, title: btn.dataset.title, url: btn.dataset.url, img: btn.dataset.img, price: btn.dataset.price });
        btn.classList.add('is-wished');
      }
      setWishlist(list.slice(0, 50));
    });
    var grid = $('[data-wishlist-grid]');
    if (grid) {
      var list = getWishlist();
      if (!list.length) {
        grid.innerHTML = '<div class="cart-empty"><h3>Your wishlist is empty</h3><p>Tap the heart on any product to save it here.</p><a class="btn btn--primary" href="/collections/all">Browse products</a></div>';
      } else {
        grid.innerHTML = '<div class="product-grid product-grid--4">' + list.map(function (w) {
          return '<div class="product-card"><div class="product-card__media">' +
            '<button class="wish-btn is-wished" data-handle="' + w.handle + '" aria-label="Remove"><svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.8"><path d="M19.5 12.57 12 20l-7.5-7.43A5 5 0 1 1 12 6.01a5 5 0 1 1 7.5 6.56Z"/></svg></button>' +
            '<a href="' + w.url + '">' + (w.img ? '<img class="primary" src="' + w.img + '" alt="">' : '') + '</a></div>' +
            '<h3 class="product-card__title"><a href="' + w.url + '">' + w.title + '</a></h3>' +
            '<div class="price"><span class="price__current">' + w.price + '</span></div></div>';
        }).join('') + '</div>';
        grid.addEventListener('click', function (e) {
          if (e.target.closest('.wish-btn')) setTimeout(function () { location.reload(); }, 150);
        });
      }
    }
  }

  /* ---------- Recently viewed ---------- */
  var RV_KEY = 'vh_recent';
  function initRecentlyViewed() {
    if (!V.recentlyViewed) return;
    var meta = $('[data-product-meta]');
    if (meta) {
      var current;
      try { current = JSON.parse(meta.textContent); } catch (e) { current = null; }
      if (current) {
        var list = [];
        try { list = JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (e) { list = []; }
        list = list.filter(function (p) { return p.handle !== current.handle; });
        list.unshift(current);
        localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12)));
      }
    }
    var grid = $('[data-recently-viewed-grid]');
    if (grid) {
      var items = [];
      try { items = JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (e) { items = []; }
      items = items.filter(function (p) { return !meta || p.handle !== JSON.parse(meta.textContent).handle; }).slice(0, parseInt(grid.dataset.limit || '4', 10));
      if (!items.length) { grid.closest('section').style.display = 'none'; return; }
      grid.innerHTML = items.map(function (p) {
        return '<div class="product-card"><div class="product-card__media"><a href="' + p.url + '">' +
          (p.img ? '<img class="primary" src="' + p.img + '" alt="">' : '') + '</a></div>' +
          '<h3 class="product-card__title"><a href="' + p.url + '">' + p.title + '</a></h3>' +
          '<div class="price"><span class="price__current">' + p.price + '</span></div></div>';
      }).join('');
    }
  }

  /* ---------- Slideshow ---------- */
  function initSlideshow() {
    $$('.slideshow').forEach(function (show) {
      var track = $('.slideshow__track', show);
      var slides = $$('.slideshow__slide', show);
      var dots = $$('.slideshow__dots button', show);
      if (!track || slides.length < 2) return;
      var idx = 0, timer = null;
      var autoplay = parseInt(show.dataset.autoplay || '0', 10);
      function go(i, smooth) {
        idx = (i + slides.length) % slides.length;
        track.scrollTo({ left: idx * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
      }
      function syncDots() {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
        idx = i;
      }
      track.addEventListener('scroll', function () { requestAnimationFrame(syncDots); }, { passive: true });
      dots.forEach(function (d, di) { d.addEventListener('click', function () { go(di); restart(); }); });
      var prev = $('.slideshow__arrow--prev', show);
      var next = $('.slideshow__arrow--next', show);
      if (prev) prev.addEventListener('click', function () { go(idx - 1); restart(); });
      if (next) next.addEventListener('click', function () { go(idx + 1); restart(); });
      function restart() {
        if (!autoplay) return;
        clearInterval(timer);
        timer = setInterval(function () { go(idx + 1); }, autoplay * 1000);
      }
      restart();
    });
  }

  /* ---------- Before / After slider ---------- */
  function initBeforeAfter() {
    $$('.ba-wrap').forEach(function (wrap) {
      var after = $('.ba-after', wrap);
      var handle = $('.ba-handle', wrap);
      function setPos(clientX) {
        var r = wrap.getBoundingClientRect();
        var pct = Math.max(4, Math.min(96, ((clientX - r.left) / r.width) * 100));
        after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
        handle.style.left = pct + '%';
      }
      function onMove(e) { setPos(e.touches ? e.touches[0].clientX : e.clientX); }
      wrap.addEventListener('mousedown', function (e) {
        onMove(e);
        function up() { document.removeEventListener('mousemove', onMove); document.removeEventListener('mouseup', up); }
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', up);
      });
      wrap.addEventListener('touchstart', onMove, { passive: true });
      wrap.addEventListener('touchmove', onMove, { passive: true });
    });
  }

  /* ---------- Countdown timers ---------- */
  function renderCountdown(el, target) {
    function tick() {
      var diff = target - Date.now();
      if (diff < 0) diff = 0;
      var d = Math.floor(diff / 86400000);
      var h = Math.floor(diff / 3600000) % 24;
      var m = Math.floor(diff / 60000) % 60;
      var s = Math.floor(diff / 1000) % 60;
      var map = { d: d, h: h, m: m, s: s };
      Object.keys(map).forEach(function (k) {
        var u = el.querySelector('[data-cd-' + k + ']');
        if (u) u.textContent = String(map[k]).padStart(2, '0');
      });
    }
    tick();
    setInterval(tick, 1000);
  }
  function initCountdowns() {
    $$('[data-countdown-to]').forEach(function (el) {
      var target = new Date(el.dataset.countdownTo).getTime();
      if (!isNaN(target)) renderCountdown(el, target);
    });
    /* Evergreen deal timer: resets per visitor every N hours */
    $$('[data-countdown-evergreen]').forEach(function (el) {
      var hours = parseFloat(el.dataset.countdownEvergreen) || 24;
      var key = 'vh_deal_' + (el.dataset.countdownKey || 'default');
      var end = parseInt(localStorage.getItem(key) || '0', 10);
      if (!end || end < Date.now()) {
        end = Date.now() + hours * 3600000;
        localStorage.setItem(key, String(end));
      }
      renderCountdown(el, end);
    });
  }

  /* ---------- Cart drawer extras ---------- */
  function initCartExtras() {
    /* Reservation countdown */
    var cc = $('[data-cart-countdown]');
    if (cc && V.cartCountdownMin) {
      var key = 'vh_cart_timer';
      var end = parseInt(sessionStorage.getItem(key) || '0', 10);
      if (!end || end < Date.now()) {
        end = Date.now() + V.cartCountdownMin * 60000;
        sessionStorage.setItem(key, String(end));
      }
      setInterval(function () {
        var diff = Math.max(0, end - Date.now());
        var m = Math.floor(diff / 60000);
        var s = Math.floor(diff / 1000) % 60;
        var t = $('[data-cart-timer]', cc);
        if (t) t.textContent = String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
        if (diff <= 0) {
          end = Date.now() + V.cartCountdownMin * 60000;
          sessionStorage.setItem(key, String(end));
        }
      }, 1000);
    }

    /* Terms gate + minimum order */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.querySelector('[name="checkout"]')) return;
      var terms = $('#vh-terms');
      if (terms && !terms.checked) {
        e.preventDefault();
        terms.closest('.cart-terms').style.color = 'var(--color-sale)';
        return;
      }
      if (V.minimumOrder > 0 && window.__cartTotal !== undefined && window.__cartTotal < V.minimumOrder) {
        e.preventDefault();
        var mo = $('.cart-min-order');
        if (mo) {
          mo.style.display = 'block';
          mo.textContent = 'Minimum order is ' + money(V.minimumOrder) + ' — add ' + money(V.minimumOrder - window.__cartTotal) + ' more to checkout.';
        }
      }
    }, true);

    /* Track cart total + savings from cart fetches */
    var origFetch = window.fetch;
    window.fetch = function () {
      var p = origFetch.apply(this, arguments);
      var url = String(arguments[0] || '');
      if (url.indexOf('/cart') > -1) {
        p.then(function (r) { return r.clone().json().catch(function () { return null; }); }).then(function (cart) {
          if (!cart || cart.total_price === undefined) return;
          window.__cartTotal = cart.total_price;
          var savings = (cart.original_total_price || cart.total_price) - cart.total_price;
          var sv = $('[data-cart-savings]');
          if (sv) {
            sv.style.display = savings > 0 ? '' : 'none';
            sv.textContent = 'You are saving ' + money(savings) + ' 🎉';
          }
          var mo = $('.cart-min-order');
          if (mo && V.minimumOrder > 0) mo.style.display = cart.total_price < V.minimumOrder && cart.item_count > 0 ? 'block' : 'none';
        }).catch(function () {});
      }
      return p;
    };
  }

  /* ---------- Quantity breaks ---------- */
  function initQtyBreaks() {
    $$('.qty-breaks').forEach(function (wrap) {
      var form = wrap.closest('form') || $('form[data-product-form]');
      if (!form) return;
      var qty = form.querySelector('input[name="quantity"]');
      wrap.addEventListener('change', function (e) {
        var input = e.target.closest('input[type="radio"]');
        if (!input) return;
        $$('.qty-break', wrap).forEach(function (b) { b.classList.toggle('is-selected', b.contains(input)); });
        if (qty) qty.value = input.value;
      });
    });
  }

  /* ---------- Product zoom ---------- */
  function initZoom() {
    if (!V.productZoom) return;
    var overlay = $('.zoom-overlay');
    if (!overlay) return;
    var main = $('[data-gallery-main] img');
    if (main) {
      main.classList.add('product-zoomed');
      main.addEventListener('click', function () {
        $('img', overlay).src = main.src;
        overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    }
    overlay.addEventListener('click', function () {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  /* ---------- Size chart modal ---------- */
  function initSizeChart() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-size-chart-open]');
      if (link) { e.preventDefault(); var m = $('#size-chart-modal'); if (m) m.classList.add('is-open'); }
      if (e.target.closest('[data-size-chart-close]')) { var m2 = $('#size-chart-modal'); if (m2) m2.classList.remove('is-open'); }
    });
  }

  /* ---------- Infinite scroll (collections) ---------- */
  function initInfiniteScroll() {
    var grid = $('[data-infinite-grid]');
    var status = $('[data-infinite-status]');
    if (!grid || !status) return;
    var nextUrl = status.dataset.nextUrl;
    var loading = false;
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting || loading || !nextUrl) return;
      loading = true;
      status.innerHTML = '<div class="infinite-spinner"></div>Loading more…';
      fetch(nextUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newCards = doc.querySelectorAll('[data-infinite-grid] > *');
          newCards.forEach(function (c) { grid.appendChild(c); });
          var newStatus = doc.querySelector('[data-infinite-status]');
          nextUrl = newStatus ? newStatus.dataset.nextUrl : null;
          status.innerHTML = nextUrl ? '' : 'You have seen everything 🏁';
          loading = false;
        })
        .catch(function () { status.textContent = ''; loading = false; });
    }, { rootMargin: '400px' });
    io.observe(status);
  }

  /* ---------- Delivery estimate dates ---------- */
  function initDelivery() {
    $$('[data-delivery-estimate]').forEach(function (el) {
      var min = parseInt(el.dataset.minDays, 10) || 4;
      var max = parseInt(el.dataset.maxDays, 10) || 9;
      var opts = { month: 'short', day: 'numeric' };
      var d1 = new Date(Date.now() + min * 86400000).toLocaleDateString(undefined, opts);
      var d2 = new Date(Date.now() + max * 86400000).toLocaleDateString(undefined, opts);
      var t = $('[data-delivery-dates]', el);
      if (t) t.textContent = d1 + ' – ' + d2;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initBackTop();
    initTabMessage();
    initCookie();
    initPopup();
    initSalesPop();
    initWishlist();
    initRecentlyViewed();
    initSlideshow();
    initBeforeAfter();
    initCountdowns();
    initCartExtras();
    initQtyBreaks();
    initZoom();
    initSizeChart();
    initInfiniteScroll();
    initDelivery();
  });
})();
